module.exports = __webpack_public_path__ + "img/theme7.709fe1a1.png";